import { UIKitIcon } from '../icon';

export const startOverIcon: UIKitIcon = {
  name: 'start-over',
  // tslint:disable-next-line: max-line-length
  data: '<svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#a)" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"><path d="M16 8.896c1.912 0 3.766.658 5.25 1.863a8.297 8.297 0 0 1 2.136 10.267 8.316 8.316 0 0 1-4.074 3.797 8.331 8.331 0 0 1-10.111-2.83 8.298 8.298 0 0 1 .718-10.461"/><path d="m18.2 11.871-2.54-2.746L18.3 6.5"/></g><defs><clipPath id="a"><path fill="#fff" transform="translate(7.18 6)" d="M0 0h17.64v20H0z"/></clipPath></defs></svg>',
};
